<template>
  <EmployeeContactsDetailForm></EmployeeContactsDetailForm>
</template>

<script>
import EmployeeContactsDetailForm from "@/modules/company/components/employees/details/contacts/EmployeeContactsDetailForm";
export default {
  name: "EmployeeContactsDetail",
  components: { EmployeeContactsDetailForm },
};
</script>

<style scoped></style>
